/**
 * Validación de formularios basada en reglas de BD.
 * Uso:
 *   import { validarCampos, validarSelects, REGLAS_MOVIMIENTO, REGLAS_MOVIMIENTO_PATIO, REGLAS_SELECTS_OBLIGATORIOS } from "../../herramientas/Validacion";
 *   const errors = validarCampos(state, REGLAS_MOVIMIENTO);
 */

export const REGLAS_MOVIMIENTO = {
  booking: { max: 100, label: "Booking" },
  po: { max: 100, label: "Po(Wo)" },
  sello: { max: 100, label: "Sello" },
  contenedor: { max: 100, label: "Contenedor" },
  destino: { max: 300, label: "Destino" },
  nota: { max: 2000, label: "Nota" },
  viaje: { max: 70, label: "Viaje" },
  cp: { max: 150, label: "CP" },
  referencia: { max: 70, label: "Referencia" },
  eco: { max: 50, label: "Eco" },
  modalidad: { max: 50, label: "Modalidad" },
  empacador: { max: 255, label: "Empacador" },
  estatusActual: { max: 300, label: "Estatus Actual" },
  serviceOrder: { max: 32, label: "Service Order" },
  woInstruction: { max: 32, label: "WO_Instruction" },
};

export const REGLAS_MOVIMIENTO_PATIO = {
  operadorNombre: { max: 200, label: "Operador Nombre" },
  operadorContacto: { max: 45, label: "Operador Contacto" },
  operadorLicencia: { max: 20, label: "Operador Licencia" },
  tractorModelo: { max: 20, label: "Unidad Modelo" },
  tractorMarca: { max: 20, label: "Unidad Marca" },
  tractorColor: { max: 200, label: "Unidad Color" },
  tractorPlaca: { max: 20, label: "Unidad Placa" },
  economicot: { max: 30, label: "Tracto Eco" },
  economicor: { max: 30, label: "Remolque Eco" },
};

export const REGLAS_SELECTS_OBLIGATORIOS = {
  idPlataforma: { label: "Plataforma" },
  idCliente: { label: "Cliente" },
  idTransportista: { label: "Transportista" },
  idOperacionTipo: { label: "Tipo de Operación" },
  idMovimientoTipo: { label: "Tipo de Movimiento" },
  idCorredor: { label: "Corredor" },
};

/**
 * Valida campos de texto contra sus límites de longitud.
 * @param {object} state - Estado del componente
 * @param {object} reglas - Objeto con { campo: { max, label } }
 * @returns {object} Errores encontrados { campo: "mensaje" }
 */
export function validarCampos(state, reglas) {
  const errors = {};
  Object.entries(reglas).forEach(([field, { max }]) => {
    const value = state[field];
    if (value && value.length > max) {
      errors[field] = `Máximo ${max} caracteres (actual: ${value.length})`;
    }
  });
  return errors;
}

/**
 * Valida que los selects obligatorios tengan un valor seleccionado.
 * @param {object} state - Estado del componente
 * @param {object} reglas - Objeto con { campo: { label } }
 * @returns {object} Errores encontrados { campo: "mensaje" }
 */
export function validarSelects(state, reglas) {
  const errors = {};
  Object.entries(reglas).forEach(([field, { label }]) => {
    if (!state[field] || !state[field].value) {
      errors[field] = `${label} es requerido`;
    }
  });
  return errors;
}
